// extracted by mini-css-extract-plugin
module.exports = {"modalWrappers":"_3E1c2","modalTexts":"_1zcOi","applePay":"_1ac8q","carImage":"_3EhUX","priceStyle":"-_HPb","carName":"fV3PS","downPayment":"_3WlHo","closeButton":"oKIhL"};